import { Dispatch, SetStateAction } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';

import { UserEndpointQueryKeys } from '../../../../Shared/constants/user/endpoints';
import { UserProfileEndpointQueryKey } from '../../../../Shared/components/TopNavigationHeader/services/endpoints';
import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { UserInterface } from '../../../../Shared/interfaces/user/UserInterfaces';
import useApiClient from '../../../../Shared/services/api';
import { editUser } from '../../../../Shared/services/user/userService';

export const useEditUserMutation = (
    setIsEditUser: Dispatch<SetStateAction<boolean>>,
    setCustomSnackbarMessage: (message: string) => void
) => {
    const queryClient = useQueryClient();
    const api = useApiClient();
    const auth = useAuth();

    return useMutation<
        UserInterface,
        ApiError,
        { userId: string; userData: Partial<UserInterface>; successMessage: string }
    >({
        mutationFn: ({
            userId,
            userData,
        }: {
            userId: string;
            userData: Partial<UserInterface>;
        }) => editUser(api, userId, userData),
        onSuccess: (_, { userId, userData, successMessage }) => {
            const currentUserEmail = auth.user?.profile?.email;
            const currentUserId = currentUserEmail?.split('@')[0];
            queryClient.invalidateQueries({
                queryKey: [UserEndpointQueryKeys.GET_USERS],
            });

            // If editing own profile, invalidate to refetch updated role/privilegedMode
            if (userId === currentUserId)
              queryClient.invalidateQueries({
                queryKey: [UserProfileEndpointQueryKey.USER_PROFILE],
            });

          setCustomSnackbarMessage(successMessage);

          setIsEditUser(false);
        },
    });
}
